import React from 'react';
import * as LucideIcons from 'lucide-react';
import { Card, CardContent, CardDescription, CardHeader, CardTitle } from '../../components/ui/card';
import { useLanguage } from '../../contexts/LanguageContext';
import { t } from '../../translations/translations';
import { SERVICES } from '../../data/mock';

export const ServicesGridSection = () => {
  const { language } = useLanguage();

  return (
    <section className="py-20 bg-[#fefdf4]">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
        <div className="text-center mb-16">
          <h2 className="text-4xl font-medium text-gray-900 mb-4">{t(language, 'sections.whatWeHandle')}</h2>
          <p className="text-xl text-gray-600 max-w-3xl mx-auto">
            {t(language, 'sections.whatWeHandleDesc')}
          </p>
        </div>

        <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-4 gap-6">
          {SERVICES.map((service) => {
            const Icon = LucideIcons[service.icon];
            return (
              <Card key={service.key} className="border-gray-200 hover:border-blue-900 hover:shadow-lg transition-all duration-300">
                <CardHeader>
                  <div className="w-12 h-12 bg-blue-50 rounded-lg flex items-center justify-center mb-4">
                    <Icon className="w-6 h-6 text-blue-900" />
                  </div>
                  <CardTitle className="text-lg">{t(language, `services.${service.key}`)}</CardTitle>
                </CardHeader>
                <CardContent>
                  <CardDescription className="text-gray-600">
                    {t(language, `services.${service.key}Desc`)}
                  </CardDescription>
                </CardContent>
              </Card>
            );
          })}
        </div>
      </div>
    </section>
  );
};
